import { Component, ErrorHandler, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { VaihdaSalasanaPyynto, VaihdaSalasanaVastaus } from '@lemon/lemonaid-lemonator-functions-and-lemonator-angular/model/kayttajahallinta'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonator.service'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'
import { Kayttaja } from '../_jaettu-lemonator/model/asiakas'

@Component({
  templateUrl: './kayttaja.vaihda-salasana.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KayttajaVaihdaSalasanaDialog implements OnInit {
  readonly uusiSalasana = signal<string>(null)
  readonly commonError = signal<string>(null)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Kayttaja,
    private dialogRef: MatDialogRef<KayttajaVaihdaSalasanaDialog>,
    private errorHandler: ErrorHandler,
    private _firebaseLemonaid: FirebaseLemonaid,
    private ladataanService: LadataanService,
  ) {}

  vaihdaSalasana() {
    this.ladataanService.aloitaLataaminen()
    const data: VaihdaSalasanaPyynto = {
      uid: this.data.avain,
    }

    this._firebaseLemonaid
      .functionsCall<VaihdaSalasanaPyynto, VaihdaSalasanaVastaus>('lemonatorVaihdaSalasana', data)
      .then(vastaus => {
        this.ladataanService.lopetaLataaminen()
        this.uusiSalasana.set(vastaus.pwd)
      })
      .catch(error => {
        this.ladataanService.lopetaLataaminen()
        this.commonError.set('Salasanan vaihtamisen yhteydessä tapahtui virhe. Ole hyvä ja ilmoita tästä ylläpidolle.')
        this.errorHandler.handleError(error)
      })
  }

  ngOnInit() {}
}
